/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-mate.agent-message.error': 'Chat opnieuw laden',
  'ai-mate.agent-message.error.aup-link-text': 'Acceptabel Gebruiksbeleid',
  'ai-mate.agent-message.error.aup-one': 'We kunnen niet reageren op de prompt.',
  'ai-mate.agent-message.error.aup-two': 'Je prompt voldoet mogelijk niet aan ons {link}. Probeer een andere prompt.',
  'ai-mate.agent-message.error.copy-trace-id': 'Traceer-ID kopiëren',
  'ai-mate.agent-message.error.network-error': 'Er lijkt een netwerkprobleem te zijn.',
  'ai-mate.agent-message.error.resend': 'Het bericht opnieuw versturen',
  'ai-mate.agent-message.error.trace-id': 'Traceer-ID: {traceId}',
  'ai-mate.browse-agents-view.close-button': 'Agentweergave sluiten',
  'ai-mate.browse-agents-view.header-title': 'Agents zoeken',
  'ai-mate.chat-history.conversationLimit':
    'Op zoek naar een oude chat? We wissen de chatgeschiedenis na 30 dagen om onze AI soepel te laten werken.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-1': "Aan welke Confluence-pagina's heb ik recent bijgedragen?",
  'ai-mate.chat-history.empty-state.atlas-home-prompt-2': 'Vind alle Jira-tickets die aan mij zijn toegewezen.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-3': 'Wat is ons reisbeleid?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-4': 'Stel een Confluence-pagina op voor een marketingcampagne.',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-5': 'Hoe kan ik een projecttijdlijn aanmaken?',
  'ai-mate.chat-history.empty-state.atlas-home-prompt-6': 'Schrijf een vervolgmail aan potentiële klanten.',
  'ai-mate.chat-history.empty-state.bitbucket-prompt-1': "Wat zijn de pull requests waarvoor 'persoon' de auteur is?",
  'ai-mate.chat-history.empty-state.browse-agents-button-text': 'Agents zoeken',
  'ai-mate.chat-history.empty-state.chat-with-agent-header': 'Chat met Rovo-Agent',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-1': 'Over deze space',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-2': 'Inzichten voor deze space',
  'ai-mate.chat-history.empty-state.confluence-home-llm-label-3': 'Suggesties voor spaces',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-1':
    "Is er nieuwe activiteit op pagina's die ik geschreven heb?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-10':
    "Heeft 'persoon' een opmerking achtergelaten op een pagina die ik heb gepubliceerd?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-11': 'Wat zijn de belangrijkste conclusies van `pagina`?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-2': 'Zijn er nieuwe opmerkingen waarin ik word vermeld?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-3':
    "Vat de meest recent gepubliceerde pagina's in deze space samen.",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-4':
    "Vat mijn bijdragen op deze pagina's van vorige week samen.",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-5':
    "Kun je deze 'pagina' op een minder technische manier schrijven?",
  'ai-mate.chat-history.empty-state.confluence-home-prompt-6': 'Maak een plansjabloon voor projectbeheer.',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-7':
    'Welk onderzoek is er naar veelvoorkomende problemen van klanten?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-8':
    'Heeft iemand in mijn team deze week een nieuwe pagina gepubliceerd?',
  'ai-mate.chat-history.empty-state.confluence-home-prompt-9':
    "Heeft 'persoon' deze week een nieuwe pagina gepubliceerd?",
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1': 'Kun je de schrijfstijl op deze pagina verbeteren?',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2': 'Schrijf een samenvatting voor deze pagina.',
  'ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3': "Geef me links naar andere relevante pagina's.",
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-1': 'Over deze pagina',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-2': 'Meer van deze pagina',
  'ai-mate.chat-history.empty-state.confluence-page-llm-label-3': 'Paginasuggestie',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-1': 'Vat samen waar ik naar kijk.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-2': 'Vat de opmerkingen op deze pagina samen.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-3':
    'Leg deze pagina aan mij uit alsof ik een beginner ben.',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-4':
    'Wie heeft deze pagina geschreven en in welk team zit diegene?',
  'ai-mate.chat-history.empty-state.confluence-page-view-prompt-5':
    'Is er in de afgelopen week iets op deze pagina veranderd?',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1': 'Over dit whiteboard',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2': 'Meer van dit whiteboard',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3': 'Inzichten op dit whiteboard',
  'ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1': 'Vat samen waar ik naar kijk.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2':
    'Benadruk hier patronen of trends die zichtbaar zijn.',
  'ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3':
    'Identificeer alle belangrijke actie-items of beslissingen die op dit whiteboard zijn vastgelegd.',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.be-productive': 'Wees productief',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.draft-content': 'Inhoud van concept',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-information': 'Vind informatie',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.find-people': 'Zoek personen',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.get-answers': 'Krijg antwoorden',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.measure-productivity': 'Meet productiviteit',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.rephrase-content': 'Formuleer de inhoud anders',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.stay-up-to-date': 'Blijf up-to-date',
  'ai-mate.chat-history.empty-state.conversation-starter-tile-label.summarize-content': 'Vat inhoud samen',
  'ai-mate.chat-history.empty-state.created-by-label': '<text>door</text> {creatorName}',
  'ai-mate.chat-history.empty-state.intro-text-headline': 'Hallo {userName}',
  'ai-mate.chat-history.empty-state.intro-text-link-text': 'Ontdek Rovo Chat en -Agents',
  'ai-mate.chat-history.empty-state.intro-text-subheadline': 'Kies een gespreksopener of stel een vraag.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1': 'Vind Jira-issues die deze week zijn bijgewerkt.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh':
    'Vind Jira-werkitems die deze week zijn bijgewerkt.',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2': 'Welke Jira-issues hebben de hoogste prioriteit?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh':
    'Welke Jira-werkitems hebben de hoogste prioriteit?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3': 'Welke Jira-issues bevatten opmerkingen die mij vermelden?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh':
    'Welke Jira-werkitems bevatten opmerkingen die mij vermelden?',
  'ai-mate.chat-history.empty-state.jira-home-prompt-4': "Vat de opmerkingen op 'deze Jira-issue' samen.",
  'ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh':
    "Vat de opmerkingen op 'dit Jira-werkitem' samen.",
  'ai-mate.chat-history.empty-state.jira-home-prompt-5': "Maak een omschrijvingssjabloon voor userstory's.",
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1': 'Over deze issue',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh': 'Over dit werkitem',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2': 'Meer over deze issue',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh': 'Meer over dit werkitem',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3': 'Inzichten voor deze issue',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh': 'Inzichten voor dit werkitem',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4': 'Issuesuggestie',
  'ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh': 'Werkitemsuggestie',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1': 'Zijn er soortgelijke Jira-issues als deze?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh':
    'Zijn er soortgelijke Jira-werkitems als deze?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-2': 'Hoe kan ik de beschrijving verbeteren?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3': 'Welke labels kan ik aan deze issue toevoegen?',
  'ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh':
    'Welke labels kan ik aan dit werkitem toevoegen?',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-1': 'Over dit project',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-2': 'Inzichten voor dit project',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-3': 'Meer van dit project',
  'ai-mate.chat-history.empty-state.jira-project-llm-label-4': 'Projectsuggestie',
  'ai-mate.chat-history.empty-state.jira-project-prompt-1': 'Welk werk is al een tijdje niet meer opgepakt?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10': 'Vind en groepeer soortgelijke Jira-issues.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh':
    'Vind en groepeer soortgelijke Jira-werkitems.',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11':
    'Zijn er Jira-issues die niet zijn gekoppeld aan de bovenliggende issue?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh':
    'Zijn er Jira-werkitems die niet zijn gekoppeld aan het bovenliggende werkitem?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-12':
    "Neem de omschrijving 'van de Jira-issue' en stem die af op de best practice.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh':
    "Neem de omschrijving 'van het Jira-werkitem' en stem die af op de best practice.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-13': "Vat de opmerkingen op 'deze Jira-issue' samen.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh':
    "Vat de opmerkingen op 'dit Jira-werkitem' samen.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-14': "Maak een omschrijvingssjabloon voor userstory's.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh':
    "Maak een omschrijvingssjabloon aan voor userstory's.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-2': 'Zijn er Jira-issues die zijn geblokkeerd?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh':
    'Zijn er Jira-werkitems die zijn geblokkeerd?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-3':
    "Noem de Jira-issues die momenteel 'In uitvoering' zijn en groepeer ze per uitvoerder.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh':
    "Noem de Jira-werkitems die momenteel 'In uitvoering' zijn en groepeer ze per uitvoerder.",
  'ai-mate.chat-history.empty-state.jira-project-prompt-4': "Hoeveel issues zijn er toegewezen aan 'persoon'?",
  'ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh':
    "Hoeveel werkitems zijn er toegewezen aan 'persoon'?",
  'ai-mate.chat-history.empty-state.jira-project-prompt-5':
    "Heeft 'persoon' een opmerking achtergelaten op een Jira-issue in deze sprint?",
  'ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh':
    "Heeft 'persoon' een opmerking achtergelaten op een Jira-werkitem in deze sprint?",
  'ai-mate.chat-history.empty-state.jira-project-prompt-6': 'Welke Jira-issues zijn niet toegewezen?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh':
    'Welke Jira-werkitems zijn niet toegewezen?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7': 'Welke Jira-issues zijn het langste open?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh':
    'Welke Jira-werkitems zijn het langste open?',
  'ai-mate.chat-history.empty-state.jira-project-prompt-8': 'Wie heeft de meeste taken?',
  'ai-mate.chat-history.empty-state.message':
    'Krijg antwoorden, genereer nieuwe ideeën en versnel het dagelijkse werk.',
  'ai-mate.chat-history.empty-state.suggestion1': 'Heb ik achterstallige tickets?',
  'ai-mate.chat-history.empty-state.suggestion2': 'Waar moet ik nu aan werken?',
  'ai-mate.chat-history.empty-state.suggestion3': 'Schrijf een update over mijn week',
  'ai-mate.chat-history.empty-state.unknown-llm-label-1': 'Suggestie',
  'ai-mate.chat-history.message-research.research-completed-notification-body':
    'Je onderzoek is voltooid en kan worden bekeken.',
  'ai-mate.chat-history.message-research.research-completed-notification-title':
    'Rovo Chat heeft het ondrzoek voltooid',
  'ai-mate.chat-history.message-research.research-expandable.collapse': 'Inklappen',
  'ai-mate.chat-history.message-research.research-expandable.expand': 'Uitvouwen',
  'ai-mate.chat-history.message-research.research-step-title-placeholder': 'Op zoek naar relevante informatie ...',
  'ai-mate.chat-history.message-research.sources-title': '{count, plural, one {1 bron} other {{count} bronnen}}',
  'ai-mate.chat-history.message-research.title': 'Diepgaand onderzoek',
  'ai-mate.chat-history.message-research.view-sources-button-label':
    '{count, plural, one {1 bron} other {{count} bronnen}}',
  'ai-mate.chat-history.store-assistant.message-actions.cancel-button': 'Annuleren',
  'ai-mate.chat-history.store-assistant.message-actions.confirm-button': 'Bevestigen',
  'ai-mate.chat-history.store-assistant.message-actions.errored-button':
    'Er is een probleem opgetreden tijdens het voltooien van deze actie',
  'ai-mate.chat-input.actions-button.label': 'Elementen invoegen',
  'ai-mate.chat-input.add-a-link-button.label': 'Een link toevoegen',
  'ai-mate.chat-input.deep-research-button.label': 'Diepgaand onderzoek',
  'ai-mate.chat-input.deleted-agent-icon-label': 'Agent verwijderd',
  'ai-mate.chat-input.deleted-agent-start-new-chat': 'Start een nieuwe chat',
  'ai-mate.chat-input.deleted-agent-warning': 'Deze Agent is verwijderd.',
  'ai-mate.chat-input.drag-and-drop-message': 'Sleep om context toe te voegen voor betere resultaten',
  'ai-mate.chat-input.file-close-icon-label': 'Bestand verwijderen',
  'ai-mate.chat-input.file-error-icon-label': 'Fout bij laden van bestand',
  'ai-mate.chat-input.link-type-ahead-button.label': 'Een link toevoegen',
  'ai-mate.chat-input.mention-someone-button.label': 'Vermeld iemand of een team',
  'ai-mate.chat-input.mention-type-ahead-button.label': 'Vermeld iemand',
  'ai-mate.chat-input.open-chat-input-buttons-label': 'Open de invoerknoppen voor de chat',
  'ai-mate.chat-input.send-button.label': 'Verzenden',
  'ai-mate.chat-input.stop-generating-button.label': 'Stoppen met genereren',
  'ai-mate.chat-input.store-user-messages.label': 'Bewaar dit bericht om de kwaliteit van de antwoorden te verbeteren',
  'ai-mate.chat-input.web-search-button.label': 'Zoeken',
  'ai-mate.chat-main-header.back-button.label': 'Terug',
  'ai-mate.chat-main-header.copy-agent-link-button.label': 'Link kopiëren',
  'ai-mate.chat-main-header.default-agent-name': 'Chat',
  'ai-mate.chat-main-header.edit-agent-button.label': 'Bewerken',
  'ai-mate.chat-main-header.link-copied-to-profile': 'URL is gekopieerd',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Verwijderen',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Naam wijzigen',
  'ai-mate.chat-view.chat-item.options-button-label': 'Chatopties',
  'ai-mate.content-renderer.profile-card.view-profile-button': 'Profiel bekijken',
  'ai-mate.content-renderer.view-code-button-label': 'Analyse bekijken',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuleren',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Het gesprek dat je probeert te verwijderen bestaat niet.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final':
    'Verwijderen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    "Gesprek ''{name}' verwijderen?",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Er is een fout opgetreden tijdens het verwijderen van dit gesprek. Probeer het opnieuw.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Weet je zeker dat je dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuleren',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Het kanaal dat je probeert te bewerken bestaat niet.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Naam',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Er is een fout opgetreden tijdens het bewerken van dit gesprek. Probeer het opnieuw.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Gesprek bewerken',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'De naam is hetzelfde als de huidige naam.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Opslaan',
  'ai-mate.conversation-list-view.back-button.label': 'Terug',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Chat sluiten',
  'ai-mate.conversation-list-view.header-title': 'Chatgeschiedenis',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nieuwe chat',
  'ai-mate.conversation-list-view.no-chat': 'Geen resultaten',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Doorzoek chats',
  'ai-mate.expander.hide-details': 'Details verbergen',
  'ai-mate.expander.show-details': 'Meer details tonen',
  'ai-mate.footer.beta': 'BÈTA',
  'ai-mate.footer.info': 'De kwaliteit van de inhoud kan verschillen',
  'ai-mate.footer.info-truncated': 'De kwaliteit van de inhoud kan verschillen',
  'ai-mate.footer.info-updated': 'De inhoud is gebaseerd op je rechten en de kwaliteit kan variëren',
  'ai-mate.footer.rovo-branding-label': '{logo} Rovo',
  'ai-mate.footer.rovo-branding-label-updated': 'Rovo {logo}',
  'ai-mate.message-renderer.error': 'Laat het ons weten als het probleem zich blijft voordoen.',
  'ai-mate.message-renderer.error-title': 'Kon de inhoud niet laden',
  'ai-mate.message-renderer.hide-sources': 'Alle bronnen verbergen',
  'ai-mate.message-renderer.show-sources':
    '{count, plural, one {{count} bron weergeven} other {{count} bronnen weergeven}}',
  'ai-mate.message-renderer.sources.sources-title': 'Bronnen',
  'ai-mate.pubsub-listener.forge-auth-faiure-message': 'Bevestiging is mislukt. Probeer het straks opnieuw.',
  'ai-mate.pubsub-listener.forge-auth-success-message': 'Bevestiging is gelukt, verstuur je prompt opnieuw.',
  'ai-mate.sidebar.agents-icon.text': 'Agents',
  'ai-mate.sidebar.agents-icon.tooltip': 'Doorzoek Rovo-Agents',
  'ai-mate.sidebar.chat-icon.text': 'Chat',
  'ai-mate.sidebar.chat-icon.tooltip': 'Chat met Rovo',
  'ai-mate.sidebar.debug-mode-icon.tooltip': 'Debug',
  'ai-mate.sidebar.get-help-icon.tooltip': 'Vraag hulp',
  'ai-mate.sidebar.give-feedback-icon.tooltip': 'Geef feedback',
  'ai-mate.sidebar.history-icon.text': 'Geschiedenis',
  'ai-mate.sidebar.history-icon.tooltip': 'Bekijk je chatgeschiedenis',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-description':
    'Er is een fout opgetreden bij het valideren van bestanden. Probeer het opnieuw.',
  'ai-mate.upload-files-to-conversation.fail-to-validate-files-title': 'Kon de bestanden niet valideren',
  'ai-mate.upload-files-to-conversation.file-invalid-icon-label': 'Het bestand is ongeldig',
  'ai-mate.upload-files-to-conversation.invalid-files-description':
    "{count, plural, one {Het bestand ''{fileNames}' wordt niet ondersteund. Reden: {reasons}} other {De bestanden ''{fileNames}' worden niet ondersteund. Redenen: {reasons}}}",
  'ai-mate.upload-files-to-conversation.invalid-files-title':
    '{count, plural, one {{count,number} bestandstype wordt niet ondersteund} other {{count,number} bestandstypen worden niet ondersteund}}',
  'ai-mate.upload-files-to-conversation.unknown-error':
    'Er heeft zich een fout voorgedaan bij het uploaden van het bestand. Probeer het opnieuw.',
  'ai-mate.upload-files-to-conversation.unsupported-file': 'Niet-ondersteund bestandstype',
  'ai-mate.upload-files-to-conversation.validation-error-file-name-missing': 'De bestandsnaam ontbreekt',
  'ai-mate.upload-files-to-conversation.validation-error-file-too-large': 'Het bestand is te groot',
  'ai-mate.upload-files-to-conversation.validation-error-invalid-content-type':
    'Het bestandstype wordt niet ondersteund',
  'ai-mate.upload-files-to-conversation.validation-error-missing-error-code': 'Het validatieresultaat is niet bekend',
  'ai-mate.upload-files-to-conversation.validation-error-not-found': 'Het validatieresultaat is niet gevonden',
  'ai-mate.upload-files-to-conversation.validation-error-unknown-error':
    'Kon het bestand niet valideren vanwege een onbekende reden',
  'chat-history.rate-limit-warning':
    '{secondsRemaining, plural, one {Wacht {secondsRemaining,number} seconde} other {Wacht {secondsRemaining,number} seconden}}',
  'chat-history.rate-limit-warning-description': 'De berichten worden te snel verzonden, een ogenblik geduld.',
  'chatHistory.storeAssistant.badResponseLabel': 'Fout antwoord',
  'chatHistory.storeAssistant.copyResponseLabel': 'Kopiëren',
  'chatHistory.storeAssistant.goodResponseLabel': 'Goed antwoord',
  'rovo-chat.chat-input.editor-context-banner.editor-context-toggle-label': 'Deze context gebruiken',
  'rovo-chat.data-sculptor-modal.cancel': 'Annuleren',
  'rovo-chat.data-sculptor-modal.no-data': 'Geen gegevens',
  'rovo-chat.data-sculptor-modal.title': 'Analyse',
  'rovo-chat.file-upload-button.label': 'Bestand uploaden',
  'rovo-chat.file-upload-button.max-files-label':
    '{maxFiles, plural, one {Limiet van {maxFiles,number} bestand bereikt} other {Limiet van {maxFiles,number} bestanden bereikt}}',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Sleep om context toe te voegen',
  'rovo-chat.message-file.icon-label': 'Bestand',
  'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label': 'Op de pagina invoegen',
  'rovo-chat.store-assistant.insert-replace.generic-insert-button-label': 'Invoegen',
  'rovo-chat.store-assistant.insert-replace.jira-insert-button-label': 'In issue invoegen',
  'rovo-chat.store-assistant.insert-replace.replace-button-label': 'Selectie vervangen',
  'rovo-chat.store-assistant.insert-replace.tooltip-message':
    'Deze functie wordt niet ondersteund in je huidige context. Selecteer, schrijf of bewerk tekst op de pagina.',
  'rovo-chat.store-assistant.sources-title': 'Bronnen:',
};
